const EPISODE_MEDIA = [
  null,
  { cover: '/images/vnext/assets/su-zhaoying.jpg', video: '/media/vnext/episode-character-preview.mp4' },
  { cover: '/images/vnext/assets/xueluo-secret-room.jpg', video: '/media/vnext/episode-scene-preview.mp4' },
  { cover: '/images/vnext/assets/ye-changge.jpg', video: '/media/vnext/episode-storyboard-preview.mp4' },
  { cover: '/images/vnext/canvas.jpg', video: '/media/vnext/episode-delivery-preview.mp4' },
];

const EPISODE_TITLES = ['故事钩子', '人物入局', '秘密浮现', '正面对峙', '阶段交付'];

export const PROTOTYPE_CASES = [
  {
    id: 'frost-lantern',
    category: '短剧',
    title: '霜灯照旧城',
    summary: '从退婚书切入，用一场错身建立人物关系，再把第一集交给画布继续生产。',
    creator: '小影实验室',
    duration: '01:36',
    cover: '/images/vnext/case-historical-romance.jpg',
    video: '/media/vnext/frost-lantern-preview.mp4',
    likes: 286,
    favorites: 91,
    workflowPublic: true,
    badge: '官方完整案例',
    episodeCount: 5,
    learningTags: ['教程', '短剧', '人物提示词'],
    tags: ['古偶女频', '角色一致性', '剧本到成片'],
    challenge: '在 90 秒内建立退婚冲突、人物关系和下一集钩子，同时保持角色造型稳定。',
    decision: '先用写作 Agent 固定人物欲望与第一集结尾，再把结构化剧本交给画布 Agent 拆镜。',
    result: '完成 12 个镜头、4 个角色/场景资产与一条可继续修改的完整画布。',
  },
  {
    id: 'two-behind-door',
    category: '剧情短片',
    title: '门后的两个人',
    summary: '用空间关系和克制表演，建立一场不说破的情感冲突。',
    creator: '小影实验室',
    duration: '00:48',
    cover: '/images/vnext/writing.jpg',
    video: '/media/vnext/two-behind-door-preview.mp4',
    likes: 162,
    favorites: 58,
    workflowPublic: true,
    badge: '课程案例',
    learningTags: ['教程', '短剧'],
    tags: ['叙事与表演', '候选稿', '局部修改'],
    challenge: '对白不能直说，但观众仍要理解两个人的关系已经发生变化。',
    decision: '让写作 Agent 先给出两个候选版本，只接受冲突更明确的一版，再做局部修改。',
    result: '保留克制对白，同时把关键动作和视线关系转成可拍的镜头。',
  },
  {
    id: 'lost-outside-cabin',
    category: '视觉短片',
    title: '舱外失联',
    summary: '在失重、碎片与氧气倒计时中，让一场危机持续升级。',
    creator: '小影实验室',
    duration: '01:12',
    cover: '/images/vnext/case-sci-fi-astronaut.jpg',
    video: '/media/vnext/lost-outside-cabin-preview.mp4',
    likes: 205,
    favorites: 73,
    workflowPublic: true,
    badge: '公开工作流',
    learningTags: ['教程', '分镜'],
    tags: ['科幻危机', '分镜规划', '镜头节奏'],
    challenge: '单一场景容易重复，需要靠景别、运镜和倒计时制造升级感。',
    decision: '先锁定空间关系，再按远景、近景、主观镜头和碎片特写组织镜头。',
    result: '用 9 个镜头完成一条空间连续、节奏清楚的危机段落。',
  },
  {
    id: 'before-moon-deer',
    category: '情绪短片',
    title: '月鹿降临以前',
    summary: '用巨物尺度、冷色月光和微小人物，建立敬畏与未知。',
    creator: '小影实验室',
    duration: '00:54',
    cover: '/images/vnext/case-fantasy-creature.jpg',
    video: '/media/vnext/before-moon-deer-preview.mp4',
    likes: 318,
    favorites: 126,
    workflowPublic: false,
    badge: '仅展示作品',
    learningTags: ['人物提示词'],
    tags: ['奇幻氛围', '巨物尺度', '情绪影像'],
    challenge: '不依赖对白，仅靠尺度、色彩和运动建立神秘情绪。',
    decision: '作者只公开成片，没有开放提示词、节点关系和素材配置。',
    result: '作品可观看和收藏，创作过程保持私有。',
  },
  {
    id: 'city-above-clouds',
    category: '宣传片',
    title: '云上之城',
    summary: '用电影级三维国漫风格，呈现东方世界观与英雄登场。',
    creator: '小影实验室',
    duration: '01:08',
    cover: '/images/vnext/case-guoman-3d.jpg',
    video: '/media/vnext/city-above-clouds-preview.mp4',
    likes: 239,
    favorites: 84,
    workflowPublic: true,
    badge: '精选案例',
    learningTags: ['教程', '分镜'],
    tags: ['3D 国漫', '风格统一', 'QC 返工'],
    challenge: '多镜头保持建筑语言、服装材质与主角造型一致。',
    decision: '用角色和场景标准图约束生成，QC 只返工有问题的镜头。',
    result: '完成统一风格的宣传短片，并保留所有可局部返工节点。',
  },
  {
    id: 'three-visual-tones',
    category: '广告片',
    title: '一件产品，三种视觉语气',
    summary: '从产品参考到镜头节奏，拆解十五秒广告的画面组织。',
    creator: '小影实验室',
    duration: '00:15',
    cover: '/images/vnext/featured-cases.jpg',
    video: '/media/vnext/three-visual-tones-preview.mp4',
    likes: 147,
    favorites: 69,
    workflowPublic: true,
    badge: '商业案例',
    learningTags: ['教程', '广告'],
    tags: ['产品视觉', '参考图', '广告节奏'],
    challenge: '同一产品需要快速比较高级、生活化和未来感三种方向。',
    decision: '锁定产品外形，仅改变布光、环境和镜头节奏，避免三条方案互相污染。',
    result: '在一个项目里保留三套可比较、可继续制作的视觉方案。',
  },
].map(item => ({
  ...item,
  episodes: EPISODE_TITLES.map((title, index) => {
    const media = index === 0 ? item : EPISODE_MEDIA[index];
    return {
      number: index + 1,
      title,
      cover: media.cover,
      video: media.video,
      duration: item.duration,
    };
  }),
}));

export function findPrototypeCase(caseId) {
  return PROTOTYPE_CASES.find(item => item.id === caseId) || PROTOTYPE_CASES[0];
}
